import React from 'react';
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Box,
  TextField,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import TransferToCellMaterials from '../../TransferToCellMaterials';
import { useDispatch, useSelector } from 'react-redux';
import { addDocumentStyle, removeDocumentStyle } from '../constants';
import {
  handleDamageDescriptionChange,
  handleClientNotAgreedDescriptionChange,
  toggleProtocolFields,
  toggleAggreedWithPerformedActivitiesDescriptionField,
  toggleDamageDescriptionField,
} from '../../../../helperFunctions/its/itsInstalProtocolHelper';
import { useStyles } from '../../../../helperFunctions/its';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  const dispatch = useDispatch();

  if (!task) return null;

  const itsInstalationProtocol = task ? task.itsInstalationProtocol : null;

  let isProtocolOpen = itsInstalationProtocol && itsInstalationProtocol.open;
  let buttonStyle = isProtocolOpen ? removeDocumentStyle : addDocumentStyle;
  let buttonText = isProtocolOpen
    ? 'Премахни протокол за инсталация'
    : 'Добави протокол за инсталация';

  const classes = useStyles();

  return (
    <>
      <Button
        variant="contained"
        style={buttonStyle}
        onClick={() => toggleProtocolFields(dispatch, data, task, itsInstalationProtocol)}
      >
        {buttonText}
      </Button>
      {isProtocolOpen ? (
        <>
          <div style={{ margin: '3px' }}>
            <TransferToCellMaterials />
          </div>
          <FormControl
            style={{ marginTop: '10px', width: '100%' }}
            component="fieldset"
            variant="standard"
          >
            <Box marginTop={1}>
              <FormControl className={classes.damageFields}>
                <FormLabel>
                  Има ли нанесени щети върху собственост на клиента при посещението:
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={task.itsInstalationProtocol.damageDescriptionField ?? 'no'}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio size="small" />}
                    label="Да. Моля опишете нанесената щета"
                    onClick={() => toggleDamageDescriptionField(dispatch, task, data, true)}
                  />
                  {task.itsInstalationProtocol.damageDescriptionField === 'yes' ? (
                    <TextField
                      multiline
                      variant="filled"
                      label="Описание"
                      value={task.itsInstalationProtocol.damageDescription}
                      onChange={event => handleDamageDescriptionChange(event, dispatch, task, data)}
                    />
                  ) : (
                    <></>
                  )}
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        size="small"
                        onClick={() => toggleDamageDescriptionField(dispatch, task, data, false)}
                      />
                    }
                    label="Не"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box marginTop={1}>
              <FormControl className={classes.damageFields}>
                <FormLabel>Съгласен ли е клиента с начина на инсталация на оборудването:</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={task.itsInstalationProtocol.agreeWithPerformedActivitiesField ?? 'yes'}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="yes"
                    control={
                      <Radio
                        size="small"
                        onClick={() =>
                          toggleAggreedWithPerformedActivitiesDescriptionField(
                            dispatch,
                            task,
                            data,
                            true
                          )
                        }
                      />
                    }
                    label="Да"
                  />
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        size="small"
                        onClick={() =>
                          toggleAggreedWithPerformedActivitiesDescriptionField(
                            dispatch,
                            task,
                            data,
                            false
                          )
                        }
                      />
                    }
                    label="Не. Моля опишете забележките:"
                  />
                  {task.itsInstalationProtocol.agreeWithPerformedActivitiesField === 'no' ? (
                    <TextField
                      multiline
                      variant="filled"
                      label="Описание"
                      value={task.itsInstalationProtocol.clientNotAgreedDescription}
                      onChange={event =>
                        handleClientNotAgreedDescriptionChange(event, dispatch, task, data)
                      }
                    />
                  ) : (
                    <></>
                  )}
                </RadioGroup>
              </FormControl>
            </Box>
          </FormControl>
        </>
      ) : null}
    </>
  );
};
